module.exports = __webpack_public_path__ + "static/media/6-9.797ca9e1.mp3";